import React, { Component } from "react";
import { MenuItem, FormControl, InputLabel, Select } from "@material-ui/core";
import styled from "styled-components";

const StyledFormControl = styled(FormControl)`
  & {
    width: ${props => (props.width)};
  }
`;

class DropDownFormControl extends Component {
  render() {
    let { width } = this.props;
    width = width || "200px";

    return (
      <StyledFormControl width={width}>
        <InputLabel htmlFor={this.props.htmlFor}>
          {this.props.labelName}
        </InputLabel>
        <Select
          value={this.props.value}
          onChange={this.props.onChange}
          inputProps={this.props.inputProps}
          margin="dense"
          disabled={this.props.disabled}
        >
          {this.props.menuItemList.map(item => (
            <MenuItem key={item.value} value={item.value}>
              {item.name}
              {" "}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    );
  }
}

export default DropDownFormControl;
